module.exports = __webpack_public_path__ + "static/media/arrow-forward-ios.49865a89.svg";